<template>
  <el-dialog title="添加租户" :visible.sync="visible" width="40%" :close-on-click-modal="false">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="租户类型:" prop="tenantType">
        <el-radio-group v-model="data.tenantType" >
          <el-radio label="1">企业</el-radio>
          <el-radio label="2">组织</el-radio>
          <el-radio label="3">专家</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="租户名称:" prop="fullName">
        <CompanyInput v-if="data.tenantType === '1'" v-model="data.fullName" :company-id="data.creditCode" @change="handleCompanyChange"/>
        <el-input v-else
                  type="text"
                  :maxlength="30"
                  v-model="data.fullName"
                  placeholder="请输入30字以内名称"
                  clearable
        />
      </el-form-item>
      <!-- <el-form-item>
        <el-button v-if="data.tenantType == '1'" type="text" @click="check">工商检测</el-button>
      </el-form-item> -->
      <el-form-item label="联系人姓名:" prop="linkNickName">
        <el-input
          type="text"
          :maxlength="6"
          v-model="data.linkNickName"
          placeholder="请输入6字以内名称"
          clearable
        />
      </el-form-item>
      <el-form-item label="联系人手机号:" prop="linkTel">
        <el-input
          type="text"
          :maxlength="30"
          v-model="data.linkTel"
          placeholder="请输入联系人手机号"
          clearable
        />
        <span class="tips-text">手机号将作为租户超级管理员账号</span>
      </el-form-item>
      <el-form-item label="所在城市" prop="area">
        <el-cascader
          v-if="visible"
          v-model="data.area"
          :options="areaOptions"
          filterable
          clearable
          @change="changeCascader"
          style="width:100%"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址:" prop="detailAddress">
        <el-input
          type="textarea"
          :maxlength="200"
          v-model="data.detailAddress"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { listAllLevelArea } from "@/api/crm/area";
import {isPhone} from "@/utils/validate";
import { saveBaseInfo } from "@/api/saas/package";
import CompanyInput from "@/views/crm/components/companyInput";
import { transferCascaderOptionsForProvince } from "@/utils";

export default {
  name: "AddClueDialog",
  components: {
    CompanyInput
  },
  props: {},
  data() {
    return {
      visible: false,
      areaOptions: [],
      rules: {
        tenantType: [
          {
            required: true,
            message: "请选择租户类型",
            trigger: "change"
          }
        ],
        fullName: [
          {
            required: true,
            message: "请输入租户名称",
            trigger: "change"
          }
        ],
        linkNickName: [
          { required: true, message: "请输入联系人姓名", trigger: "change" }
        ],
        linkTel: [
          { required: true, message: "请输入联系人手机号", trigger: "change" },
          { validator: this.checkMobile, trigger: "blur" }
        ]
      },
      data: {
        confirmFlag: 0, // 二次确认
        tenantType: '1',
        fullName: null,
        creditCode: null,
        linkNickName: null,
        linkTel: null,
        area: null,
        cityId: null,
        districtId: null,
        provinceId: null,
        detailAddress: null
      }
    };
  },
  created() {
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.data.creditCode = null;
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    changeCascader(e) {
      this.data.districtId = e[2];
      this.data.cityId = e[1];
      this.data.provinceId = e[0];
    },
    checkMobile (rule, value, callback) {
      // 非必填
      if (!value) {
        callback()
      } else if (isPhone(value)) {
        // 填了客户名称，才去校验手机号。所以需要在填写客户名称后再手动触发下手机号校验
        callback()
      } else {
        callback(new Error('请输入正确格式'))
      }
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          saveBaseInfo({
            ...this.data,
            confirmFlag: this.confirmFlag
            })
            .then(response => {
              loading.close();
              if(response.repeatFlag){
                let _this = this
                this.$confirm(response.msg, '提示', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                .then((res) => {
                  if(res === 'confirm'){
                    _this.confirmFlag = 1
                    _this.confirm()
                  }
                })
              }else {
                this.$emit("success");
                this.visible = false;
                this.msgSuccess("租户创建成功");
              }
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    handleCompanyChange(companyName, companyId) {
      this.data.creditCode = companyId ? companyId : ''
    },
  }
};
</script>
